/**
 * Browser/build contract for the consent-safe, same-tab affiliate handoff.
 *
 * This module must stay side-effect free: the Node prerenderer imports it when
 * generating the synchronous marketing bootstrap.
 */
export const AFFILIATE_VIA_PARAM = 'via';
export const SS_PENDING_TOKEN = 'a7y-aff-pending-token';

/**
 * A7Y-2814: meta tag the edge worker injects when `?via=` resolves to an
 * offer. Its `content` is the JSON `{"discountPercent":<n>}`.
 */
export const REFERRAL_OFFER_META = 'a7y-referral-offer';

/**
 * A7Y-2814: same-tab, session-scoped offer cache. It carries the offer across
 * the native `/` → `/scan` document navigation (which drops `?via=`, so the
 * worker cannot re-inject there). Never durable, never a network write.
 */
export const SS_REFERRAL_OFFER = 'a7y-aff-offer';
